import type { JWTContextUser } from '@savvy/deprecated-shared/api/user-api';
import { isSavvyTestUserEmail } from '@savvy/deprecated-shared/utils/internal-savvy';
import defaultGuard from '@savvy/utils/default-guard';

export function getClientStageRedirectRoute(pathname: string, user: JWTContextUser | null) {
  const clientStage = user?.clientStage;
  const currentPath = pathname;
  if (user?.role === 'NON_ADVISORY_USER') {
    return '/portfolio';
  }

  // Some dashboard pages are accessible to non-fully onboarded clients
  // Savvy employees can access all pages
  if (
    [
      '/dashboard',
      '/dashboard/advisor',
      '/dashboard/account',
      '/tasks',
      '/portfolio',
      '/risk-questionnaires/take',
    ].includes(currentPath) ||
    currentPath.startsWith('/account-setup') ||
    currentPath.startsWith('/dashboard/tax') ||
    currentPath.startsWith('/files') ||
    currentPath.startsWith('/dashboard/reports') ||
    isSavvyTestUserEmail(user?.email)
  ) {
    return null;
  }

  switch (clientStage) {
    case 'fully_onboarded':
      if (['/welcome', '/transition', '/onboarding'].includes(currentPath)) {
        return '/portfolio';
      }
      return null;
    case 'account_setup_flow':
      if (currentPath !== '/account-setup') {
        return '/dashboard';
      }
      return null;
    case 'onboarding_flow':
    case 'post_onboarding_waiting_area':
      if (currentPath !== '/onboarding') {
        return '/dashboard';
      }
      return null;
    case 'intake_flow':
    case 'post_intake_waiting_area':
      if (currentPath !== '/welcome') {
        return '/dashboard';
      }
      return null;
    case null:
    case undefined:
      return null;
    default:
      return defaultGuard(clientStage, null);
  }
}
